import { useState } from "react";

// ── VEHICLE DATA ──────────────────────────────────────────────────────────────
const VEHICLE_DATA = {
  "Acura":         ["ILX","Integra","MDX","RDX","TLX","ZDX"],
  "Audi":          ["A3","A4","A5","A6","A7","A8","e-tron","Q3","Q5","Q7","Q8","TT"],
  "BMW":           ["2 Series","3 Series","4 Series","5 Series","7 Series","8 Series","i4","iX","X1","X2","X3","X4","X5","X6","X7","Z4"],
  "Buick":         ["Enclave","Encore","Encore GX","Envision"],
  "Cadillac":      ["CT4","CT5","Escalade","LYRIQ","XT4","XT5","XT6"],
  "Chevrolet":     ["Blazer","Bolt EV","Colorado","Corvette","Equinox","Malibu","Silverado 1500","Silverado 2500HD","Suburban","Tahoe","Traverse","Trax"],
  "Chrysler":      ["300","Pacifica","Voyager"],
  "Dodge":         ["Challenger","Charger","Durango","Hornet"],
  "Ford":          ["Bronco","Bronco Sport","Edge","Escape","Explorer","F-150","F-250","F-350","Maverick","Mustang","Mustang Mach-E","Ranger","Transit"],
  "GMC":           ["Acadia","Canyon","Sierra 1500","Sierra 2500HD","Terrain","Yukon"],
  "Honda":         ["Accord","Civic","CR-V","HR-V","Odyssey","Passport","Pilot","Ridgeline"],
  "Hyundai":       ["Elantra","IONIQ 5","IONIQ 6","Kona","Palisade","Santa Fe","Sonata","Tucson","Venue"],
  "Infiniti":      ["Q50","Q60","QX50","QX55","QX60","QX80"],
  "Jeep":          ["Cherokee","Compass","Gladiator","Grand Cherokee","Renegade","Wrangler"],
  "Kia":           ["Carnival","EV6","Forte","K5","Niro","Seltos","Sorento","Soul","Sportage","Telluride"],
  "Land Rover":    ["Defender","Discovery","Discovery Sport","Range Rover","Range Rover Evoque","Range Rover Sport"],
  "Lexus":         ["ES","GS","GX","IS","LC","LS","LX","NX","RX","UX"],
  "Lincoln":       ["Aviator","Corsair","Nautilus","Navigator"],
  "Mazda":         ["CX-30","CX-5","CX-50","CX-90","Mazda3","Mazda6","MX-5 Miata"],
  "Mercedes-Benz": ["A-Class","C-Class","CLA","E-Class","EQS","G-Class","GLA","GLC","GLE","GLS","S-Class"],
  "Mitsubishi":    ["Eclipse Cross","Outlander","Outlander Sport"],
  "Nissan":        ["Altima","Armada","Frontier","Kicks","Leaf","Maxima","Murano","Pathfinder","Rogue","Sentra","Titan","Versa"],
  "Ram":           ["1500","2500","3500","ProMaster"],
  "Rivian":        ["R1S","R1T"],
  "Subaru":        ["Ascent","BRZ","Crosstrek","Forester","Impreza","Legacy","Outback","Solterra","WRX"],
  "Tesla":         ["Cybertruck","Model 3","Model S","Model X","Model Y"],
  "Toyota":        ["4Runner","Camry","Corolla","Crown","GR86","Highlander","Land Cruiser","Prius","RAV4","Sequoia","Sienna","Tacoma","Tundra","Venza","bZ4X"],
  "Volkswagen":    ["Atlas","Golf","ID.4","Jetta","Passat","Taos","Tiguan"],
  "Volvo":         ["C40","S60","S90","V60","XC40","XC60","XC90"],
};

const VEHICLE_MAKES = Object.keys(VEHICLE_DATA).sort();
const VEHICLE_YEARS = Array.from({ length: 31 }, (_, i) => String(2025 - i));
const CONDITIONS    = ["New","Used","Certified Pre-Owned"];
const MAX_MILEAGES  = ["Any","Under 10,000","Under 25,000","Under 50,000","Under 75,000","Under 100,000"];
const BUDGETS       = ["Under $15,000","$15,000 – $25,000","$25,000 – $40,000","$40,000 – $60,000","$60,000 – $80,000","Over $80,000"];

// ── MARKETPLACE LINKS ─────────────────────────────────────────────────────────
function getMarketplaceLinks(year, make, model, condition, maxMileage, budget) {
  const q   = encodeURIComponent(`${year} ${make} ${model}`);
  const mk  = encodeURIComponent(make);
  const mo  = encodeURIComponent(model);
  const isNew = condition === "New";
  const isCPO = condition === "Certified Pre-Owned";

  return [
    {
      name:  "CarGurus",
      icon:  "G",
      color: "#00a0e3",
      badge: "Best deal ratings",
      note:  "Shows Great Deal / Good Deal / Fair Deal ratings",
      url:   `https://www.cargurus.com/Cars/new/nl_Tesla_d${isNew ? "?inventory=new" : ""}&zip=&trim=&minYear=${year}&maxYear=${year}&entitySelectingHelper.selectedEntity=${mk}%20${mo}`,
    },
    {
      name:  "Cars.com",
      icon:  "C",
      color: "#e63946",
      badge: "Largest inventory",
      note:  "Search new, used, and CPO listings",
      url:   `https://www.cars.com/shopping/results/?keyword=${q}&stock_type=${isNew ? "new" : isCPO ? "cpo" : "used"}&year_min=${year}&year_max=${year}`,
    },
    {
      name:  "AutoTrader",
      icon:  "A",
      color: "#f47920",
      badge: "Local dealer network",
      note:  "Filter by dealer distance and price",
      url:   `https://www.autotrader.com/cars-for-sale/${isNew ? "new" : "used-cars"}/${encodeURIComponent(make)}/${encodeURIComponent(model)}?startYear=${year}&endYear=${year}`,
    },
    {
      name:  "TrueCar",
      icon:  "T",
      color: "#0066cc",
      badge: "No-haggle pricing",
      note:  "See what others paid — transparent pricing",
      url:   `https://www.truecar.com/prices-new/listings/${encodeURIComponent(make)}/${encodeURIComponent(model)}/?year=${year}`,
    },
    {
      name:  "Carvana",
      icon:  "V",
      color: "#00aed9",
      badge: "Online only, 7-day return",
      note:  "Buy 100% online, delivered to your door",
      url:   `https://www.carvana.com/cars/${encodeURIComponent(make)}?year[]=${year}`,
    },
    {
      name:  "Vroom",
      icon:  "R",
      color: "#6b21a8",
      badge: "Online only",
      note:  "No-haggle used cars, delivered nationwide",
      url:   `https://www.vroom.com/cars?year_min=${year}&year_max=${year}&make=${mk}&model=${mo}`,
    },
    {
      name:  "CarMax",
      icon:  "M",
      color: "#003087",
      badge: "No-haggle, in-store",
      note:  "Test drive in-store, no-pressure buying",
      url:   `https://www.carmax.com/cars/${encodeURIComponent(make)}/${encodeURIComponent(model)}`,
    },
    {
      name:  "eBay Motors",
      icon:  "E",
      color: "#e53238",
      badge: "Auction & Buy Now",
      note:  "Best for rare trims and below-market deals",
      url:   `https://www.ebay.com/b/Cars-Trucks/${encodeURIComponent(make)}_${encodeURIComponent(model)}?Year=${year}`,
    },
  ];
}

// ── AI PROMPT ─────────────────────────────────────────────────────────────────
function carBuyingPrompt(year, make, model, condition, budget, maxMileage) {
  return `Return ONLY raw JSON with car buying intelligence for a ${year} ${make} ${model} (${condition}).
Budget: ${budget}. ${maxMileage !== "Any" ? "Max mileage: " + maxMileage : ""}

Schema:
{
  "msrp_range": {"low": 0, "high": 0},
  "invoice_price": 0,
  "fair_market_value": 0,
  "typical_dealer_asking": 0,
  "average_discount_off_msrp": 0,
  "incentives_available": [],
  "best_time_to_buy": "",
  "negotiation_tips": [],
  "red_flags": [],
  "ownership_costs": {
    "avg_insurance_monthly": 0,
    "avg_fuel_monthly": 0,
    "avg_maintenance_annual": 0,
    "depreciation_1yr": 0,
    "depreciation_3yr": 0
  },
  "reliability_score": 0,
  "reliability_notes": "",
  "common_issues": [],
  "alternatives": [
    {"make": "", "model": "", "year": ${year}, "why": "", "price_difference": 0}
  ],
  "mioprice_verdict": "",
  "verdict_score": "great_deal"
}

Rules:
- All prices in USD
- invoice_price: what dealer actually pays (typically 3-8% below MSRP)
- fair_market_value: what you should actually pay
- typical_dealer_asking: what dealers usually list at
- average_discount_off_msrp: realistic % discount achievable
- incentives_available: manufacturer rebates, financing deals, loyalty bonuses
- best_time_to_buy: specific advice (end of month, end of quarter, December, model year changeover etc.)
- negotiation_tips: 4-5 specific, actionable tips for this exact vehicle
- red_flags: 3-4 things to watch for with this vehicle/year
- reliability_score: 1-10
- common_issues: known problems with this year/model
- alternatives: 2-3 similar vehicles worth considering
- mioprice_verdict: 2-3 sentence honest assessment — is this a good buy?
- verdict_score: "great_deal" / "good_deal" / "fair_deal" / "overpriced"`;
}

// ── API CALL ──────────────────────────────────────────────────────────────────
async function callAgent(prompt) {
  const resp = await fetch("/api/anthropic", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-haiku-4-5-20251001",
      max_tokens: 4000,
      messages: [{ role: "user", content: prompt }],
    }),
  });
  if (!resp.ok) throw new Error(`API error ${resp.status}`);
  const data = await resp.json();
  const text = data.content?.find(b => b.type === "text")?.text || "";
  const f = text.indexOf("{"), l = text.lastIndexOf("}");
  if (f === -1) throw new Error("No JSON in response");
  return JSON.parse(text.slice(f, l + 1));
}

// ── HELPERS ───────────────────────────────────────────────────────────────────
const inp = { width: "100%", padding: "10px 12px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, outline: "none", boxSizing: "border-box", background: "#fff" };
const lbl = { fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block", textTransform: "uppercase", letterSpacing: 0.5 };
const fld = { display: "flex", flexDirection: "column" };

function fmt(n) { return n ? `$${Number(n).toLocaleString()}` : "—"; }

// ── VERDICT BADGE ─────────────────────────────────────────────────────────────
function VerdictBadge({ score }) {
  const v = {
    great_deal: { label: "Great Deal ✓", bg: "#f0fdf4", border: "#bbf7d0", color: "#15803d" },
    good_deal:  { label: "Good Deal",    bg: "#eff6ff", border: "#bfdbfe", color: "#1d4ed8" },
    fair_deal:  { label: "Fair Deal",    bg: "#fffbeb", border: "#fde68a", color: "#b45309" },
    overpriced: { label: "Overpriced ⚠️", bg: "#fef2f2", border: "#fecaca", color: "#dc2626" },
  }[score] || { label: score, bg: "#f8fafc", border: "#e2e8f0", color: "#6b7280" };
  return (
    <span style={{ fontSize: 13, fontWeight: 700, padding: "4px 14px", borderRadius: 20, background: v.bg, border: `1.5px solid ${v.border}`, color: v.color }}>
      {v.label}
    </span>
  );
}

// ── MARKETPLACE ROW ───────────────────────────────────────────────────────────
function MarketplaceRow({ site }) {
  return (
    <a href={site.url} target="_blank" rel="noopener noreferrer"
      style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 16px", borderRadius: 12, border: "1.5px solid #e5e7eb", background: "#fff", textDecoration: "none", marginBottom: 8 }}
      onMouseEnter={e => e.currentTarget.style.borderColor = site.color}
      onMouseLeave={e => e.currentTarget.style.borderColor = "#e5e7eb"}>
      <div style={{ width: 38, height: 38, borderRadius: 10, background: site.color, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 900, flexShrink: 0 }}>
        {site.icon}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>{site.name}</span>
          <span style={{ fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 20, background: `${site.color}15`, color: site.color }}>{site.badge}</span>
        </div>
        <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>{site.note}</div>
      </div>
      <div style={{ fontSize: 13, fontWeight: 700, color: site.color, flexShrink: 0 }}>Search →</div>
    </a>
  );
}

// ── MAIN COMPONENT ────────────────────────────────────────────────────────────
export default function BuyACar() {
  const [year, setYear]         = useState("");
  const [make, setMake]         = useState("");
  const [model, setModel]       = useState("");
  const [condition, setCondition] = useState("Used");
  const [budget, setBudget]     = useState("");
  const [maxMileage, setMaxMileage] = useState("Any");

  const [loading, setLoading]   = useState(false);
  const [result, setResult]     = useState(null);
  const [error, setError]       = useState(null);
  const [links, setLinks]       = useState(null);

  const canSearch = year && make && model;
  const vehicleLabel = year && make && model ? `${year} ${make} ${model}` : null;

  const search = async () => {
    if (!canSearch) return;
    setLoading(true); setError(null); setResult(null); setLinks(null);
    try {
      const data = await callAgent(carBuyingPrompt(year, make, model, condition, budget, maxMileage));
      setResult(data);
      setLinks(getMarketplaceLinks(year, make, model, condition, maxMileage, budget));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 16px 40px", fontFamily: "system-ui, -apple-system, sans-serif" }}>

      {/* Header */}
      <div style={{ marginBottom: 20, padding: "16px 20px", background: "linear-gradient(135deg, #1e3a5f 0%, #7c3aed 100%)", borderRadius: 16, color: "#fff" }}>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>🛒 Buy a Car</div>
        <div style={{ fontSize: 13, opacity: 0.85 }}>See what the dealer paid, what others paid, and how to negotiate the best deal</div>
      </div>

      {/* Search Form */}
      <div style={{ background: "#f8fafc", borderRadius: 12, border: "1.5px solid #e2e8f0", padding: "14px 16px", marginBottom: 16 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", marginBottom: 10, textTransform: "uppercase", letterSpacing: 0.5 }}>🚗 Vehicle I Want to Buy</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 12 }}>
          <div style={fld}>
            <label style={lbl}>Year</label>
            <select value={year} onChange={e => { setYear(e.target.value); setMake(""); setModel(""); }} style={inp}>
              <option value="">Select year</option>
              {VEHICLE_YEARS.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <div style={fld}>
            <label style={lbl}>Make</label>
            <select value={make} onChange={e => { setMake(e.target.value); setModel(""); }}
              style={{ ...inp, opacity: year ? 1 : 0.5 }} disabled={!year}>
              <option value="">{year ? "Select make" : "Year first"}</option>
              {VEHICLE_MAKES.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div style={fld}>
            <label style={lbl}>Model</label>
            <select value={model} onChange={e => setModel(e.target.value)}
              style={{ ...inp, opacity: make ? 1 : 0.5 }} disabled={!make}>
              <option value="">{make ? "Select model" : "Make first"}</option>
              {(VEHICLE_DATA[make] || []).map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
          <div style={fld}>
            <label style={lbl}>Condition</label>
            <select value={condition} onChange={e => setCondition(e.target.value)} style={inp}>
              {CONDITIONS.map(c => <option key={c}>{c}</option>)}
            </select>
          </div>
          <div style={fld}>
            <label style={lbl}>Budget</label>
            <select value={budget} onChange={e => setBudget(e.target.value)} style={inp}>
              <option value="">Any budget</option>
              {BUDGETS.map(b => <option key={b}>{b}</option>)}
            </select>
          </div>
          {condition !== "New" && (
            <div style={fld}>
              <label style={lbl}>Max mileage</label>
              <select value={maxMileage} onChange={e => setMaxMileage(e.target.value)} style={inp}>
                {MAX_MILEAGES.map(m => <option key={m}>{m}</option>)}
              </select>
            </div>
          )}
        </div>
      </div>

      <button onClick={search} disabled={!canSearch || loading}
        style={{ width: "100%", padding: 13, borderRadius: 12, border: "none", background: !canSearch ? "#e5e7eb" : loading ? "#a78bfa" : "#7c3aed", color: !canSearch ? "#9ca3af" : "#fff", fontSize: 15, fontWeight: 700, cursor: !canSearch || loading ? "not-allowed" : "pointer", marginBottom: 20 }}>
        {loading ? "Analyzing market data..." : canSearch ? `Research ${vehicleLabel}` : "Select a vehicle to research"}
      </button>

      {error && <div style={{ background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 12, padding: "14px 18px", marginBottom: 16, color: "#dc2626", fontSize: 14 }}>⚠️ {error}</div>}

      {result && (
        <div>

          {/* Verdict */}
          <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #e5e7eb", padding: 20, marginBottom: 16, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, marginBottom: 12 }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: "#111" }}>MioPrice Verdict</div>
              <VerdictBadge score={result.verdict_score} />
            </div>
            <div style={{ fontSize: 14, color: "#374151", lineHeight: 1.7, marginBottom: 12 }}>{result.mioprice_verdict}</div>
            <div style={{ fontSize: 12, color: "#9ca3af" }}>Reliability score: <strong style={{ color: "#374151" }}>{result.reliability_score}/10</strong> — {result.reliability_notes}</div>
          </div>

          {/* Price Intelligence */}
          <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #e5e7eb", padding: 20, marginBottom: 16, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 14 }}>💰 Price Intelligence</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 14 }}>
              {[
                ["MSRP Range", `${fmt(result.msrp_range?.low)} – ${fmt(result.msrp_range?.high)}`, "#6b7280"],
                ["Dealer Invoice Price", fmt(result.invoice_price), "#1d4ed8"],
                ["Fair Market Value", fmt(result.fair_market_value), "#15803d"],
                ["Typical Dealer Asking", fmt(result.typical_dealer_asking), "#dc2626"],
              ].map(([label, value, color]) => (
                <div key={label} style={{ padding: "12px 14px", borderRadius: 10, background: "#f8fafc", border: "1px solid #e5e7eb" }}>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.4 }}>{label}</div>
                  <div style={{ fontSize: 18, fontWeight: 800, color }}>{value}</div>
                </div>
              ))}
            </div>
            <div style={{ padding: "12px 14px", borderRadius: 10, background: "#f0fdf4", border: "1.5px solid #bbf7d0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ fontSize: 13, color: "#15803d", fontWeight: 600 }}>💡 Target price (what you should pay)</div>
              <div style={{ fontSize: 22, fontWeight: 900, color: "#15803d" }}>{fmt(result.fair_market_value)}</div>
            </div>
            {result.average_discount_off_msrp > 0 && (
              <div style={{ marginTop: 8, fontSize: 12, color: "#6b7280" }}>
                Typical buyers get <strong>{result.average_discount_off_msrp}% off MSRP</strong> on this vehicle
              </div>
            )}
          </div>

          {/* Negotiation Tips */}
          {result.negotiation_tips?.length > 0 && (
            <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #e5e7eb", padding: 20, marginBottom: 16, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 12 }}>🤝 Negotiation Tips</div>
              {result.best_time_to_buy && (
                <div style={{ padding: "10px 14px", background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 10, marginBottom: 12, fontSize: 13, color: "#1d4ed8" }}>
                  ⏰ <strong>Best time to buy:</strong> {result.best_time_to_buy}
                </div>
              )}
              {result.negotiation_tips.map((tip, i) => (
                <div key={i} style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                  <div style={{ width: 24, height: 24, borderRadius: "50%", background: "#7c3aed", color: "#fff", fontSize: 11, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{i + 1}</div>
                  <div style={{ fontSize: 13, color: "#374151", lineHeight: 1.6 }}>{tip}</div>
                </div>
              ))}
              {result.incentives_available?.length > 0 && (
                <div style={{ marginTop: 12, padding: "10px 14px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#15803d", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.4 }}>Current Incentives</div>
                  {result.incentives_available.map((inc, i) => (
                    <div key={i} style={{ fontSize: 12, color: "#374151", marginBottom: 3 }}>✓ {inc}</div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Red Flags */}
          {result.red_flags?.length > 0 && (
            <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #fecaca", padding: 20, marginBottom: 16, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#dc2626", marginBottom: 12 }}>⚠️ Watch Out For</div>
              {result.red_flags.map((flag, i) => (
                <div key={i} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                  <span style={{ color: "#dc2626", flexShrink: 0 }}>•</span>
                  <div style={{ fontSize: 13, color: "#374151", lineHeight: 1.5 }}>{flag}</div>
                </div>
              ))}
              {result.common_issues?.length > 0 && <>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", marginTop: 10, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.4 }}>Known Issues This Year/Model</div>
                {result.common_issues.map((issue, i) => (
                  <div key={i} style={{ fontSize: 12, color: "#374151", marginBottom: 3 }}>• {issue}</div>
                ))}
              </>}
            </div>
          )}

          {/* Ownership Costs */}
          {result.ownership_costs && (
            <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #e5e7eb", padding: 20, marginBottom: 16, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 12 }}>📊 True Cost of Ownership</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                {[
                  ["Insurance", `${fmt(result.ownership_costs.avg_insurance_monthly)}/mo`, "🛡️"],
                  ["Fuel", `${fmt(result.ownership_costs.avg_fuel_monthly)}/mo`, "⛽"],
                  ["Maintenance", `${fmt(result.ownership_costs.avg_maintenance_annual)}/yr`, "🔧"],
                  ["Depreciation (1yr)", fmt(result.ownership_costs.depreciation_1yr), "📉"],
                  ["Depreciation (3yr)", fmt(result.ownership_costs.depreciation_3yr), "📉"],
                ].map(([label, value, icon]) => (
                  <div key={label} style={{ padding: "10px 12px", borderRadius: 10, background: "#f8fafc", border: "1px solid #e5e7eb" }}>
                    <div style={{ fontSize: 16, marginBottom: 4 }}>{icon}</div>
                    <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 2 }}>{label}</div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#111" }}>{value}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Alternatives */}
          {result.alternatives?.length > 0 && (
            <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #e5e7eb", padding: 20, marginBottom: 16, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 12 }}>🔄 Also Consider</div>
              {result.alternatives.map((alt, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", borderRadius: 10, background: "#f8fafc", border: "1px solid #e5e7eb", marginBottom: 8 }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700 }}>{alt.year} {alt.make} {alt.model}</div>
                    <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>{alt.why}</div>
                  </div>
                  {alt.price_difference !== 0 && (
                    <div style={{ fontSize: 13, fontWeight: 700, color: alt.price_difference < 0 ? "#15803d" : "#dc2626", flexShrink: 0 }}>
                      {alt.price_difference < 0 ? `${fmt(Math.abs(alt.price_difference))} less` : `${fmt(alt.price_difference)} more`}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Marketplace Links */}
          <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #e5e7eb", padding: 20, marginBottom: 16, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#111", marginBottom: 6 }}>🔍 Search Listings</div>
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 14 }}>Armed with the fair market value above, search these sites and negotiate confidently</div>
            {links?.map((site, i) => <MarketplaceRow key={i} site={site} />)}
            <button onClick={() => links?.forEach((site, i) => setTimeout(() => window.open(site.url, '_blank'), i * 300))}
              style={{ width: "100%", marginTop: 8, padding: "12px", borderRadius: 12, border: "2px solid #7c3aed", background: "#fff", color: "#7c3aed", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
              Open All {links?.length} Sites at Once →
            </button>
          </div>

          <div style={{ padding: "12px 16px", background: "#f8fafc", borderRadius: 10, fontSize: 11, color: "#9ca3af", lineHeight: 1.6 }}>
            ⚠️ Prices and market data are AI estimates based on typical market conditions. Always verify with real listings before purchasing. MioPrice is not a licensed auto dealer.
          </div>
        </div>
      )}
    </div>
  );
}
